// Chemins relatifs à la base `/api/v1` du client HTTP (comme `kybEndpoints`).
const mandates = (caseId: string) =>
  `/compliance/kyb/legal-entity-cases/${caseId}/mandates`;

const kybMandateEndpoints = {
  mandates,
  mandate: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}`,
  documents: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/documents`,
  documentDownload: (
    caseId: string,
    mandateId: string,
    mandateDocumentId: string,
  ) => `${mandates(caseId)}/${mandateId}/documents/${mandateDocumentId}/download`,
  validity: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/validity`,
  activationEligibility: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/activation/eligibility`,
  activationMfaChallenge: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/activation/mfa-challenge`,
  activation: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/activation`,
  revocationReasons: (caseId: string) => `${mandates(caseId)}/revocation-reasons`,
  revocationImpact: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/revocation/impact`,
  revocationMfaChallenge: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/revocation/mfa-challenge`,
  revocation: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/revocation`,
  delegations: (caseId: string, mandateId: string) =>
    `${mandates(caseId)}/${mandateId}/delegations`,
};

export default kybMandateEndpoints;
